class CPCVariant extends HTMLElement{
  constructor() {
    super()
  }
  connectedCallback() {
    this.addEventListener("click", this.handleEvent.bind(this) )
  }

  handleEvent(e) {
    if(e.target.classList.contains("new-pcmv-option")) {
      let btn = e.target;
      let {id} = e.target.dataset || null;
    
      console.log(btn, id)
    }
    
  }
}

customElements.define("pcm-variant", CPCVariant)